<template>
  <transition name="el-zoom-in-center">
    <el-dialog
      title="修改当前用户信息"
      :visible.sync="update.show"
      width="45%"
      center
    >
      <el-form ref="update.form" :model="update.form" label-width="100px" :rules="rules">
        <el-form-item label="终端名字" prop="name">
          <el-input v-model="update.form.name" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="终端手机" prop="phone">
          <el-input v-model="update.form.phone" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="选择地区" prop="provinceId">
              <el-col :span="4">
                <el-select
                  style="width:90%"
                  clearable
                  v-model="update.form.provinceId"
                  placeholder="请选择省份"
                  @change="getcity(update.form.provinceId)"
                >
                  <el-option
                    v-for="item in province"
                    :key="item.code"
                    :label="item.province"
                    :value="item.code"
                  />
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-select
                  style="width:90%"
                  clearable
                  v-model="update.form.cityId"
                  placeholder="请选择市"
                  @change="getdistrict(update.form.cityId)"
                >
                  <el-option
                    v-for="item in city"
                    :key="item.code"
                    :label="item.city"
                    :value="item.code"
                  />
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select
                  clearable
                  v-model="update.form.areaId"
                  style="width:100%"
                  placeholder="请选择区"
                >
                  <el-option
                    v-for="item in district"
                    :key="item.code"
                    :label="item.area"
                    :value="item.code"
                  />
                </el-select>
              </el-col>
            </el-form-item>
          <el-form-item label="详细地址" prop="address">
          <el-input type="textarea" v-model="update.form.address" placeholder="详细地址"></el-input>
        </el-form-item>
         <el-form-item label="所属上级" prop="phone">
          <el-select
                  clearable
                  v-model="update.form.parentUserUuid"
                  style="width:50%"
                  placeholder="所属上级"
                >
                  <el-option
                    v-for="item in parentUserlist"
                    :key="item.userUuid"
                    :label="item.name"
                    :value="item.userUuid"
                  />
                </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="resetForm('update.form')">重置</el-button> -->
        <el-button type="primary" @click="submitadd('update.form')">确 定</el-button>
      </span>
    </el-dialog>
  </transition>
</template>
<script>
import {  findByParentCode } from "@/api/orgin";
import {  vipsearch,userupdate } from "@/api/market/channel";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    update: {
      type: Object,
      default: () => {
        return {
          show: false,
           row: {},
          // 步骤数据
          form: {
            parentUserUuid:'',
            companyName: null,
            name: null,
            phone: null,
            provinceId: null,
            cityId: null,
            areaId: null,
            address: "",
          },
        };
      }
    }
  },
  data() {
    return {
      //基础数据
      parentUserlist:[],
      // 省市区联动下拉
       province: [],
      city: [],
      district: [],
      show: true,
      // 步骤2表格数据
      rules: {
        Remark: [
          { required: true, message: "请输入备注", trigger: "blur" }
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ]
      }
    };
  },
  mounted(){
    // 获取省下拉
    findByParentCode().then(response => {
      this.province = response.data;
    });
    vipsearch({page:1,rows:100,userType:5,state:1}).then(response => {
        this.parentUserlist = response.data.rows;
      });
  },
  methods: {
        // 获取市
    getcity(code) {
      this.city = [];
      this.update.form.cityId = "";
      this.update.form.areaId = "";
      findByParentCode({ paretnCode: code }).then(response => {
        this.city = response.data;
        this.editVisible = true;
      });
    },
    propgetcity(code){
      findByParentCode({ paretnCode: code }).then(response => {
        this.city = response.data;
        this.editVisible = true;
      });
    },
    // 获取区
    getdistrict(code) {
      this.district = [];
      this.update.form.areaId = "";
      findByParentCode({ paretnCode: code }).then(response => {
        this.district = response.data;
        this.editVisible = true;
      });
    },
    propgetdistrict(code){
      findByParentCode({ paretnCode: code }).then(response => {
        this.district = response.data;
        this.editVisible = true;
      });
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          this.update.row = this.update.form;
          userupdate(this.update.row).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "修改成功!"
              });
              this.search();
              this.update.show = false; 
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
